/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { LiquidityProvider } from './liquidityProvider';
import { Pair } from './pair';

export interface OrderLog {
  id?: number;
  orderId?: number;
  pairId?: number;
  pair?: Pair;
  logTime?: string;
  newOrderStatus?: OrderLog.NewOrderStatusEnum;
  comment?: string;
  leavesQty?: number;
  activeQty?: number;
  filledQty?: number;
  lastQty?: number;
  realLastPrice?: number;
  clientLastPrice?: number;
  realExecVolume?: number;
  clientExecVolume?: number;
  liquidityProviderId?: number;
  liquidityProvider?: LiquidityProvider;
  hedgedQty?: number;
  requestInQuoteAsset?: boolean;
  baseAssetFee?: number;
  baseAssetFeeConverted?: number;
  lastBaseAssetFee?: number;
  lastBaseAssetFeeConverted?: number;
  lastQuoteAssetPrice?: number;
  lpFilledQty?: number;
  side?: OrderLog.SideEnum;
  accountId?: number;
  account?: Account;
  lpLastQty?: number;
}
export namespace OrderLog {
  export const NewOrderStatusEnum = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED',
    Filled: 'FILLED',
    PartiallyFilled: 'PARTIALLY_FILLED',
    PartiallyFilledCanceled: 'PARTIALLY_FILLED_CANCELED',
    Rejected: 'REJECTED',
    WaitingTrigger: 'WAITING_TRIGGER',
  } as const;
  export type NewOrderStatusEnum = (typeof NewOrderStatusEnum)[keyof typeof NewOrderStatusEnum];
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
